import { GetFunds, payoutTransactions, fetchFundsViewV2, addFunds } from "../../services/backendAPI";
import { calculateFundsData } from "../../hooks/useFundsCalculator";


export const fetchFundDetails = () => (dispatch) => {
  GetFunds().then(({ data }) => {
    dispatch({
      type: "SET_FUNDS",
      payload: data,
    });
  }).catch((err) => console.log("Unable to fetch fund details", err));
};

export const fetchFundsView = () => (dispatch) => {
  fetchFundsViewV2().then((response) => {
    console.log("111111111111111111", response);
    dispatch({
      type: "SET_FUNDS_VIEW_V2",
      payload: response.result,
    });
  }).catch((err) => console.log("Unable to fetch funds view v2", err));
};

// New function to refresh funds data with better visibility handling
export const refreshFundsAction = (forceRefresh = false) => (dispatch) => {
  // Do not auto-refresh at all unless explicitly forced
  if (!forceRefresh) {
    // For debugging only - to be removed in production
    console.log("Funds auto-refresh skipped - explicit refresh required");
    return;
  }

  // Skip refresh if document is not visible
  if (document.visibilityState !== 'visible') {
    console.log("Skipping funds refresh - document not visible");
    return;
  }

  // Add throttling/debouncing mechanism to prevent excessive calls
  // Check if we've already refreshed recently
  const lastRefreshTime = window._lastFundsRefreshTime || 0;
  const now = Date.now();
  const REFRESH_COOLDOWN = 5000; // 5 seconds minimum between refreshes

  if (now - lastRefreshTime < REFRESH_COOLDOWN) {
    console.log("Skipping funds refresh - called too frequently");
    return;
  }

  // Store refresh time
  window._lastFundsRefreshTime = now;

  console.log("Refreshing funds data");

  // Fetch both fund details and funds view
  dispatch(fetchFundDetails());

  fetchFundsViewV2()
    .then((response) => {
      if (response && response.result) {
        console.log("Funds data refreshed successfully");

        // Update the funds view data
        dispatch({
          type: "SET_FUNDS_VIEW_V2",
          payload: response.result,
        });

        // Get the state after update (need to use getState in actual implementation)
        // This is a stub - the actual implementation would need getState from redux-thunk
        const fundsData = response.result;

        // Calculate derived funds values
        const calculatedFunds = calculateFundsData(fundsData);

        // Update calculated funds
        if (Object.keys(calculatedFunds).length > 0) {
          dispatch({
            type: "SET_CALCULATED_FUNDS",
            payload: calculatedFunds
          });
        }
      }
    })
    .catch((err) => {
      console.error("Error refreshing funds data:", err);
      dispatch({
        type: "SET_FUNDS_ERROR",
        payload: err.message || "Failed to refresh funds data"
      });
    });
};

export const fetchPayoutTransactions = (payload) => (dispatch) => {
  payoutTransactions(payload).then(({ data }) => {
    dispatch({
      type: "SET_PAYOUT_TRANSACTIONS",
      payload: data,
    });
  }).catch((err) => console.log("Unable to fetch payout transactions", err));
};

export const executeAddFunds = (payload) => () => {

  addFunds(payload).then(({ data }) => {
    return data?.data?.payUrl;
  }).catch((err) => console.log("Unable to add funds", err));
};

export const updateFundsFromWebSocket = (wsData) => (dispatch, getState) => {
  // Ensure we have valid data
  if (!wsData || !Array.isArray(wsData) || wsData.length === 0) {
    console.log("Invalid WebSocket funds data received", wsData);
    return;
  }

  try {
    // Get the first item from the array (most recent funds data)
    const fundsData = wsData[0];

    console.log("Processing funds WebSocket data:", fundsData);

    // First, update the raw funds data in Redux
    dispatch({
      type: "UPDATE_FUNDS_DATA_FROM_WS",
      payload: fundsData
    });

    // Get the updated state and position metrics for PnL data
    const state = getState();
    const positionMetrics = state.portfolio.positionMetrics || {};

    // Calculate derived funds values using the calculator utility
    const calculatedFunds = calculateFundsData(fundsData, {
      realizedPnL: positionMetrics.realizedPnL || 0,
      unrealizedPnL: positionMetrics.unrealizedPnL || 0,
      totalPnL: positionMetrics.totalPnL || 0
    });

    // Log the calculated funds for debugging
    console.log("Calculated funds from WebSocket data:", calculatedFunds);

    // Update the calculated funds in Redux
    if (Object.keys(calculatedFunds).length > 0) {
      dispatch({
        type: "SET_CALCULATED_FUNDS",
        payload: calculatedFunds
      });
    }
  } catch (error) {
    console.error("Error processing WebSocket funds data:", error);
  }
};
